import React from "react";
import Typography from '@material-ui/core/Typography';

export default function Footer({
  ...props
}) {
  const divStyle = {
    bottom: 0,
    right: 0,
    position: "fixed",
    paddingRight: "1rem"
  }
    return (
      <Typography fontWeight="fontWeightLight" style={divStyle} component="div">
        {/*<p>Support link</p>*/}
      </Typography>
    )
}
